import styled from '@emotion/styled';
import { Text } from '../text';
/**
 * Component that is used as a helper text for form fields.
 */
export const Helper = styled(Text) `
  color: ${({ theme, color }) => color ? theme.input.color : theme.input.helperColor};
`;
Helper.defaultProps = {
    as: 'span',
    variant: 'xs',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVscGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvaGVscGVyL0hlbHBlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0saUJBQWlCLENBQUM7QUFDckMsT0FBTyxFQUFFLElBQUksRUFBYSxNQUFNLFNBQVMsQ0FBQztBQUkxQzs7R0FFRztBQUVILE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQWE7V0FDcEMsQ0FBQyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQzVCLEtBQUssQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsV0FBVztDQUN0RCxDQUFDO0FBRUYsTUFBTSxDQUFDLFlBQVksR0FBRztJQUNwQixFQUFFLEVBQUUsTUFBTTtJQUNWLE9BQU8sRUFBRSxJQUFJO0NBQ2QsQ0FBQyJ9